import React from 'react';
import TopBackground from '../../../../img/bg-matiere-active-top.png';

/**
 * Background section component with hero image and overlay
 * @returns {JSX.Element} Background section
 */
const BackgroundSection = () => {
  return (
    <div
      className="absolute top-0 left-0 w-full overflow-hidden z-1"
      style={{ height: '600px' }}
    >
      <div className="relative w-full h-full">
        <img
          src={TopBackground}
          className="w-full h-full object-cover"
          alt="Top Background"
        />
        <div className="absolute inset-0 fade-top-white"></div>
      </div>
    </div>
  );
};

export default BackgroundSection;